import axios from "@/libs/api.request";
import {downloadFile} from './data'

//获取所有频道会话
export const getChannelGroup = (form)=>{
  const params = {...form}
  return axios.request({
    url: '/api/channel/findChannelGroup',
    params,
    method: 'get',
  })
}
//获取历史消息
export const getHistoryMessage = (form)=>{
  const data = {...form}
  return axios.request({
    url: '/api/channel/findMessage',
    data,
    method: 'post',
  })
}
//根据id获取会话详情
export const getDetailById = (form)=>{
  const params = {...form}
  return axios.request({
    url: '/api/channel/findDetail',
    params,
    method: 'get',
  })
}
//文件上传
export const fileUpload = (data)=>{
  return axios.request({
    url: '/api/common/upload',
    data,
    method: 'post',
    contentType:false,
    processData:false
  })
}

export const fileDownloadFormat = (path,name,callback,tick) => {
  const params = {path}
  params.fileName = path;
  let options = {
    url: '/api/common/download',
    method: 'get',
    data: null,
    params: params,
    name: name,
    callback: callback,
    tick:tick
  }
  downloadFile(options)
}
//编辑会话名称
export const editSessionName = (form)=>{
  const data = {...form}
  return axios.request({
    url: '/api/channel/session/editInfo',
    data,
    method: 'post',
  })
}
//解散会话
export const deleteSession = (form)=>{
  const data = {...form}
  return axios.request({
    url: '/api/channel/session/delete',
    data,
    method: 'post',
  })
}
//离开会话
export const exitSession = (form)=>{
  const data = {...form}
  return axios.request({
    url: '/api/channel/session/exit',
    data,
    method: 'post',
  })
}
//获取未选择的成员
export const unSelected = (form)=>{
  const data = {...form}
  return axios.request({
    url: '/api/channel/member/unselect',
    data,
    method: 'post',
  })
}
//编辑会话成员
export const editMember = (form)=>{
  const data = {...form}
  return axios.request({
    url: '/api/channel/session/editMember',
    data,
    method: 'post',
  })
}
//查询全部频道会话及成员
export const queryChannelAndMembers = (params)=>{
  return axios.request({
    url: '/api/channel/findAll',
    params,
    method: 'get',
  })
}
//创建会话
export const createSession = (data)=>{
  return axios.request({
    url: '/api/channel/session/create',
    data,
    method: 'post',
  })
}



// WEBPACK FOOTER //
// ./src/api/chatChannel.js